// GET:  /api/v1/supportingArticles/getPresignedPathForSupportingArticleUpload

import { useMutation, useQuery } from 'react-query';
import { GetRequest, request } from '../utils/axios-utils';

export const GetImageUploadURL = QueryParams => {
    return GetRequest({
        url: '/supportingArticles/getPresignedPathForSupportingArticleUpload',
        QueryParams,
        method: 'GET',
    });
};

export const PostSupportingArticle = reqBody => {
    return request({ url: '/supportingArticles', method: 'POST', data: reqBody });
};

export const UseImageUploadURL = (onSuccess, select) => {
    return useQuery('imageUploadUrl', GetImageUploadURL, {
        onSuccess: onSuccess ? onSuccess : null,
        select: data => data.data,
    });
};

const generateCodesForFx = () => {
    return request({
        method: 'get',
        url: `/supportingArticles/generateFxCode`,
    });
};
export const useGenerateFxCodes = (onSuccess, onError) => {
    return useMutation({
        mutationFn: generateCodesForFx,
        onSuccess: onSuccess,
        onError: onError,
    });
};
